import { useState } from 'react';
import { Panel, Flex, Input, Button, Typography } from '@maxhub/max-ui';
import { completeOnboarding } from '../api/auth.ts';

interface OnboardingPageProps {
  onComplete: () => void;
}

export function OnboardingPage({ onComplete }: OnboardingPageProps) {
  const [fullName, setFullName] = useState('');
  const [buildingNumber, setBuildingNumber] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const buildingNumberValue = Number(buildingNumber);
  const isValid =
    fullName.trim().length > 0 &&
    Number.isInteger(buildingNumberValue) &&
    buildingNumberValue >= 1 &&
    buildingNumberValue <= 106;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!isValid) return;
    setLoading(true);
    setError(null);
    try {
      await completeOnboarding({
        fullName: fullName.trim(),
        buildingNumber: buildingNumberValue,
      });
      onComplete();
    } catch {
      setError('Не удалось сохранить данные. Попробуйте ещё раз.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Panel
      style={{
        minHeight: '100vh',
        padding: '2rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Flex direction="column" align="center" gap={4} style={{ marginBottom: '2rem' }}>
        <div style={{ fontSize: '3rem' }}>🏠</div>
        <Typography.Headline variant="large-strong" style={{ display: 'block' }}>
          Расскажите о себе
        </Typography.Headline>
      </Flex>

      <Panel
        mode="secondary"
        style={{ width: '100%', maxWidth: 400, borderRadius: 12, padding: '1.5rem' }}
      >
        <form onSubmit={handleSubmit}>
          <Typography.Label
            style={{ display: 'block', opacity: 0.6, marginBottom: '1.5rem', lineHeight: '1.6' }}
          >
            Эти данные нужны для привязки к дому и формирования квитанций.
          </Typography.Label>

          <div style={{ marginBottom: '1rem' }}>
            <Typography.Label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 500 }}>
              ФИО собственника
            </Typography.Label>
            <Input
              mode="primary"
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Иванов Иван Иванович"
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <Typography.Label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 500 }}>
              Номер корпуса
            </Typography.Label>
            <Input
              mode="primary"
              type="number"
              min={1}
              max={106}
              value={buildingNumber}
              onChange={(e) => setBuildingNumber(e.target.value)}
              placeholder="Например: 12"
            />
          </div>

          {error && (
            <Typography.Label style={{ display: 'block', color: '#dc2626', marginBottom: '1rem' }}>
              {error}
            </Typography.Label>
          )}

          <Button
            type="submit"
            mode="primary"
            size="large"
            stretched
            loading={loading}
            disabled={!isValid || loading}
          >
            Продолжить
          </Button>
        </form>
      </Panel>
    </Panel>
  );
}
